module.exports = __webpack_public_path__ + "static/img/culture-honesty.8ce0dbf0.png";